<template>
  <div class="multiSelect">
    <div class="multiSelectAutoLookup" v-if="!roa.isReadOnly()">
      <AutocompleterLookup :filter="filter" :val="valRef()" :id="id()" :template="table" :minimalSearchStringLength="minimalSearchStringLength" :placeholder="title" :queryParams="queryParams"/> 
      <a v-if="isSelected && checkDuplicate && !isCurrentInSelection" :title="title" @click="add" style="cursor: pointer; padding-left:5px;"><u>Auswahl übernehmen?</u></a>
    </div>
    <div class="multiSelectAutoList">
      <div class="multiSelectList" v-for="sel in elemArray.visibleDataElements.value">
        <span class="vueforms-delete" v-if="!roa.isReadOnly()" @click="sel.delete()" :title="titleDelete" ></span>
        <FormField :attribute="sel.$$[attributeName]" :readOnlyAnalyzer="true"/>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, shallowRef, computed, watch } from "vue";
import AutocompleterLookup from "./AutocompleterLookup.vue";
import FormField from "vueforms/src/components/xmlrdbfield/FormField.vue";
import ElementArray from "vueforms/src/xmlrdb-data/ElementArray";
import {getReadOnlyAnalyzer} from "vueforms/src/components/xmlrdbfield/formFieldVM";

export default {
  props:{
    table: String, // Tabellenname für die Anzeige der zur Verfügung stehenden Daten
    title: { // Title für den 'Hinzufügen' Button
      type: String,
      default: "Hinzuf&uuml;gen"
    },
    titleDelete: { // Title für den 'Hinzufügen' Button
      type: String,
      default: "L&ouml;schen"
    },
    minimalSearchStringLength: {
      type: Number,
      default: 0
    },
    elemArray: ElementArray, // ElementArray für die m-zu-n Tabelle
    attributeName: String, // Attributname des DataElements aus ElementArray
    checkDuplicate: { // Sollen doppelte Einträge verhindert werden?
      type: Boolean,
      default: true
    },
    filter: {
       type: Object,
       default: undefined
    },
    readOnlyAnalyzer: {
      type: [Object, Function, Boolean],
      default: undefined
    },
    queryParams: {
      type: String,
      default: ""
    },
    otherField: Object, // otherField.fieldName entspricht Spaltenname des zweiten Feldes (MASSNAHME_NR, ZA_NR, ...) der m-zu-n Tabelle
                      // otherField.value entspricht Wert des zweiten Feldes der m-zu-n Tabelle
    otherField2: Object // otherField2.fieldName entspricht Spaltenname des dritten Feldes (MASSNAHME_NR, ZA_NR, ...) der m-zu-n-zu-o Tabelle
  },                   // otherField2.value entspricht Wert des dritten Feldes der m-zu-n-zu-o Tabelle
  components: {
    AutocompleterLookup,
    FormField
  },
  setup(props){
    let id = ref(null);
    let isSelected = computed(() => { return id.value != null });
    let valRef = shallowRef();
    const roa = getReadOnlyAnalyzer(props);

    const isCurrentInSelection = computed(() => {
      for (let val of props.elemArray.visibleDataElements.value) {
          if (val.$[props.attributeName] == id.value) {
            return true;
          }
        }
        return false;
    });
    function add() {
      if (props.checkDuplicate) { 
        if (isCurrentInSelection.value) return;
      }
      let newElem = props.elemArray.createFreeElement();
      newElem.$$[props.attributeName].selected.value = valRef.value;
      newElem.$[props.otherField.fieldName] = props.otherField.value;
      if (props.otherField2) {
        newElem.$[props.otherField2.fieldName] = props.otherField2.value;
      }
      props.elemArray.addElement(newElem);
    }

    watch(id, () => {
      if (id.value) {
        add();
        id.value = null;
        valRef.value = null;
      }
    });
  
    return {
      id: () => id,
      isSelected,
      add,
      valRef: () => valRef,
      roa,
      isCurrentInSelection
    }
  }
}
</script>

<style>


</style>